import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageService {

    constructor() { }
    loginSubject = new Subject<any>();
    menuListSubject = new Subject<any>();
    pwaInstallSubject = new Subject<any>();


    getValue(key: string): string {
        let data = localStorage.getItem(key)
        return data ? data : "";
    }

    setValue(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    removeValue(key: string): void {
        localStorage.removeItem(key);
    }

    getPageMenuRights(pageName: string): any {
        var menulist = JSON.parse(this.getValue(StorageKey.menuRights));
        let menu: any = [];

        if (menulist) {
            menulist.forEach((element: any) => {
                if (element.name == pageName) {
                    menu = element;
                    return menu;
                }

                if (element?.childMenus) {
                    element.childMenus.forEach((elementChild: any) => {

                        if (elementChild.name == pageName) {
                            menu = elementChild;
                            return menu;
                        }
                    })
                }
            });
        }
        return menu;
    }

    getAllMenuRights() {
        return JSON.parse(this.getValue(StorageKey.menuRights));
    }
}

export class StorageKey {
    public static currentUser = 'currentUser';
    public static authToken = 'authToken';
    public static companyData = 'companyData';
    public static menuRights = 'menuRights';
}
